var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobSuccessOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_1648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 30.2907L53.7077 22.7495L54.7712 12.6538L44.8392 10.5511L39.7728 1.75L30.5001 5.89412L21.2273 1.75L16.161 10.5511L6.22891 12.6538L7.29228 22.7495L0.5 30.2907L7.29216 37.8319L6.22879 47.9276L16.1608 50.0303L21.2272 58.8314L30.4999 54.6872L39.7727 58.8314L44.839 50.0303L54.7711 47.9276L53.7076 37.8319L60.5 30.2907Z",
    fill: "#1E56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30.1694L26.875 36.75L38.5 24.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_1648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.5 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobSuccessOtp);
export default __webpack_public_path__ + "static/media/mob-success-otp.8ae4324c0bf9b253be862e5361afc1c7.svg";
export { ForwardRef as ReactComponent };